import { render } from "./ShoprentInvoice2.vue?vue&type=template&id=4bc39504&scoped=true"
import script from "./ShoprentInvoice2.vue?vue&type=script&lang=js"
export * from "./ShoprentInvoice2.vue?vue&type=script&lang=js"

import "./ShoprentInvoice2.vue?vue&type=style&index=0&id=4bc39504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc39504"]])

export default __exports__